"use client"

import Link from "next/link"
import { FormEvent, useState } from "react"
import { Header } from "@/components/header"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { toast } from "sonner"

const categoryOptions = [
  "마케팅",
  "이미지 생성",
  "콘텐츠 작성",
  "개발/코딩",
  "데이터 분석",
  "업무 자동화",
  "교육",
  "기타",
]

export default function WaitlistPage() {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [portfolioUrl, setPortfolioUrl] = useState("")
  const [message, setMessage] = useState("")
  const [selectedCategories, setSelectedCategories] = useState<string[]>([])

  const toggleCategory = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((item) => item !== category) : [...prev, category],
    )
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (selectedCategories.length === 0) {
      toast.error("관심 카테고리를 1개 이상 선택해주세요")
      return
    }

    toast.success("웨이팅 리스트 등록이 완료되었습니다")
    setName("")
    setEmail("")
    setPortfolioUrl("")
    setMessage("")
    setSelectedCategories([])
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 py-16">
        <Card className="mx-auto max-w-2xl">
          <CardHeader>
            <CardTitle className="text-2xl">판매자 웨이팅 리스트 등록</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-muted-foreground">
            <form className="space-y-5" onSubmit={handleSubmit}>
              <div className="space-y-2">
                <Label htmlFor="name" className="text-foreground">
                  이름
                </Label>
                <Input
                  id="name"
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="이름을 입력해주세요"
                  className="placeholder:text-muted-foreground/70"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="email" className="text-foreground">
                  이메일
                </Label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="example@email.com"
                  className="placeholder:text-muted-foreground/70"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="portfolioUrl" className="text-foreground">
                  포트폴리오 URL
                </Label>
                <Input
                  id="portfolioUrl"
                  type="url"
                  required
                  value={portfolioUrl}
                  onChange={(e) => setPortfolioUrl(e.target.value)}
                  placeholder="https://your-portfolio.com"
                  className="placeholder:text-muted-foreground/70"
                />
              </div>

              <div className="space-y-3">
                <Label className="text-foreground">관심 카테고리</Label>
                <div className="flex flex-wrap gap-2">
                  {categoryOptions.map((category) => {
                    const isSelected = selectedCategories.includes(category)
                    return (
                      <Button
                        key={category}
                        type="button"
                        variant={isSelected ? "default" : "outline"}
                        onClick={() => toggleCategory(category)}
                        className={
                          isSelected
                            ? ""
                            : "text-muted-foreground hover:text-foreground"
                        }
                      >
                        {category}
                      </Button>
                    )
                  })}
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="message" className="text-foreground">
                  자기소개/메시지
                </Label>
                <Textarea
                  id="message"
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="간단한 자기소개와 판매하고 싶은 프롬프트 분야를 알려주세요"
                  className="min-h-32 placeholder:text-muted-foreground/70"
                />
              </div>

              <div className="flex gap-3 pt-1">
                <Button type="submit">
                  제출하기
                </Button>
                <Button asChild type="button" variant="outline" className="text-foreground">
                  <Link href="/">홈으로 돌아가기</Link>
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  )
}
